import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerExperienceTicketHeaderState } from '@core/store';

export const customerExperienceTicketState = createFeatureSelector('customerExperienceTicketHeader');

export const getCustomerExperienceTicketHeader = createSelector(
    customerExperienceTicketState,
    (state: CustomerExperienceTicketHeaderState) => state
);
